import { WarehouseRoutingCheckIn } from "src/types/database";
import { EuRelabelCheckInRoutingType } from "src/types/database/euRelabelCheckIn";

const GXO_EU_ROUTING_TYPES = new Set<EuRelabelCheckInRoutingType>(["EU_STANDARD", "EU_RELABEL"]);

function euQtyForProductInCheckIn(checkIn: WarehouseRoutingCheckIn, productId: string): number {
  const row = checkIn.products.find((p) => p.id === productId);
  if (!row) {
    return 0;
  }
  if (row.euReceivedQty !== undefined) {
    return row.euReceivedQty;
  }
  let sum = 0;
  for (const instruction of checkIn.routingInstructions) {
    if (!GXO_EU_ROUTING_TYPES.has(instruction.type)) {
      continue;
    }
    const rp = instruction.products.find((x) => x.id === productId);
    if (rp) {
      sum += rp.quantity;
    }
  }
  return sum;
}

export function aggregateGxoEuQtyByProductId(checkIns: WarehouseRoutingCheckIn[]): Record<string, number> {
  const totals: Record<string, number> = {};
  for (const checkIn of checkIns) {
    for (const p of checkIn.products) {
      const q = euQtyForProductInCheckIn(checkIn, p.id);
      totals[p.id] = (totals[p.id] ?? 0) + q;
    }
  }
  return totals;
}
